import { memo, useEffect, useRef } from 'react';

import { isWCFRequired } from '~/constants';
import { RefKeys, refManager } from '~/managers/refManager';
import { ENTRY_SOURCE } from '~/store/slices/settingsSlice';

import AboutClansSlider from '~/Components/AboutClansSlider/AboutClansSlider';

import styles from './About.scss';

const About = () => {
  const ref = useRef<HTMLDivElement>(null);
  const appRef = refManager.getRef(RefKeys.APP);

  useEffect(() => {
    if (!isWCFRequired) {
      return;
    }

    const appContainer = appRef?.current;
    const refContainer = ref.current;

    if (!appContainer || !refContainer) {
      return;
    }

    const handleWheel = (e: WheelEvent) => {
      appContainer.scrollTo({ top: e.deltaY > 0 ? appContainer.scrollHeight : 0, behavior: 'smooth' });
    };

    const handleScroll = () => {
      refContainer.style.transform = `translateY(-${Math.floor(appContainer.scrollTop || 0)}px)`;
    };

    appContainer.addEventListener('scroll', handleScroll, { passive: false });
    appContainer.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      appContainer.removeEventListener('scroll', handleScroll);
      appContainer.removeEventListener('wheel', handleWheel);
    };
  }, [appRef]);

  return (
    <div className={styles.wrapper} ref={ref}>
      <AboutClansSlider source={ENTRY_SOURCE.ABOUT} />
    </div>
  );
};

export default memo(About);
